<template>
    <el-drawer
        :title="detailData.title"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body">
                    <el-form :model="detailData" ref="detailData" label-position="top" size="small">
                        <el-form-item
                            label="部门："
                            prop="row.name"
                            :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                        >
                            <el-input
                                placeholder="部门名称"
                                v-model="detailData.row.name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="描述："
                            prop="row.describe"
                            :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                        >
                            <el-input
                                type="textarea"
                                :rows="2"
                                placeholder="描述信息"
                                v-model="detailData.row.describe"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="small"
                                :loading="detailData.loading.submit"
                                @click="SubmitDepartment('detailData')"
                                >保 存</el-button
                            >
                            <el-button size="small" @click="detailParam.visible = false"
                                >取 消</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
export default {
    inject: ['reload'],
    props: ['detailParam'],
    data() {
        return {
            detailData: {
                loading: {
                    form: false,
                    submit: false
                },
                title: null,
                row: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            if (this.detailParam.row.id) {
                this.detailData.title = '修改部门'
            } else {
                this.detailData.title = '创建部门'
            }
            this.detailData.row = this.detailParam.row
        })
    },
    methods: {
        SubmitDepartment(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.detailData.loading.submit = true
                    this.$request({
                        url: '/api/v1/department_add',
                        params: {
                            ...this.detailData.row
                        }
                    }).then(res => {
                        this.detailData.loading.submit = false
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.reload()
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
</style>
